import React from 'react';
import { joinClasses } from '../../../../../Utils/className.util';
import styles from './DENTButton.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	title: string;
	onClick: () => void;
	isSelected?: boolean;
}

const DENTButton = ({ title, onClick, isSelected }: Props) => {
	const { t } = useTranslation();

	return (
		<span
			className={joinClasses([
				styles.button,
				isSelected ? styles.selected : '',
			])}
			onClick={onClick}>
			{t(title)}
		</span>
	);
};

export default DENTButton;
